import {
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalNext,
    ToastProvider,
} from '@jutro/components';
import _ from 'lodash';
import React from 'react';
import StatusComponent from './StatusComponent';
import SubmissionIntakeUtil from './SubmissionIntakeUtil';

function StatusModalComponent(props) {
    const { cancelBtnLabel, isOpen, onReject, history } = props;

    const callbackMap = {
        submissionCreatedCallback: {
            call: async (submissionNumber) => {
                ToastProvider.toast({
                    autoClose: false,
                    autoFocus: false,
                    message: `Created submissions: ${submissionNumber}`,
                    type: 'success',
                });
                let jumpSubmissionNumber = submissionNumber;
                // for arrayList, get the first item
                if (_.get(jumpSubmissionNumber, 'length') === 1) {
                    jumpSubmissionNumber = _.get(jumpSubmissionNumber, '0');
                }
                // jump to the first submission when result with multiple submissions
                if (_.get(jumpSubmissionNumber, 'length') > 10) {
                    jumpSubmissionNumber = jumpSubmissionNumber.substring(
                        0,
                        10
                    );
                }
                history.push(`/quotes/${jumpSubmissionNumber}/summary`);
            },
            needModalOnReject: true,
        },
        uploadFailCallback: {
            call: () => {
                // do nothing
            },
            needModalOnReject: false,
        },
        deleteSubmissionCallback: {
            call: () => {
                // do nothing
            },
            needModalOnReject: false,
        },
        closeSubmissionCallback: {
            call: async () => {
                // do nothing
            },
            needModalOnReject: true,
        },
    };

    const modalCallbackMap = SubmissionIntakeUtil.generateModalCallbackMap(
        callbackMap,
        onReject
    );

    return (
        <ModalNext isOpen={isOpen} className="full modalHeaderWithBorder">
            <ModalHeader className="" />
            <ModalBody id="statusModal">
                <StatusComponent {...props} callbackMap={modalCallbackMap} />
            </ModalBody>
            <ModalFooter
                contentLayout={{
                    component: 'flex',
                    componentProps: {
                        alignItems: 'middle',
                        justifyContent: 'between',
                    },
                }}
            >
                <Button
                    onClick={onReject}
                    type="outlined"
                    label={cancelBtnLabel}
                />
            </ModalFooter>
        </ModalNext>
    );
}

StatusModalComponent.propTypes = {};
StatusModalComponent.defaultProps = {};
export default StatusModalComponent;
